/* eslint-disable no-unsafe-optional-chaining */
import React, { useState, useCallback, useEffect, useRef, useContext } from 'react'
import { PubSub } from 'pubsub-js'
import classNames from 'classnames'
import qs from 'qs'
import sortBy from 'lodash/sortBy'
import { Dropdown, message, Spin } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import Upload from 'meinian-package/src/component/upload/image'
import Input from 'meinian-package/src/baseComponent/input'
import Textarea from 'meinian-package/src/component/textarea'
import Modal from 'meinian-package/src/component/modal'
import request from 'meinian-package/src/utils/request'
import { Dropdown as Mndropdown, Ul, Li, Loading } from 'meinian-package/src/baseComponent'
import Button from 'meinian-package/src/baseComponent/button'
import { PicturePreview } from '../../baseComponent'
import { useSocket, SOCKET_STATUS } from './websocket'
import './editProcess.less'
import getBoxLabelRetList from '../../common/getBoxLabelRetList'
import { AccountContext } from '../../context'

const getData = async ({ unionId, blogId, inspirationId, platformId, collectId, isMarking, shareUrl }) => {
  const _params = {
    unionId,
    onlyClothes: 0,
    inspirationId,
    platformId,
    shareUrl,
  }
  isMarking ? _params.collectId = collectId : _params.blogId = blogId
  let result = await request.get('/zhikuan/ins/inspiration/blog-detail', { params: _params, })
  result = result || []
  result.forEach((r) => {
    r.boxLabelRetList = getBoxLabelRetList(r.boxLabelRetList)
  })
  return sortBy((result || []), ['rank'])
}

const DESIGN_TITLE = [
  {
    index: 0,
    title: '款式图管理',
  },
  {
    index: 1,
    title: '基本信息',
  },
  {
    index: 2,
    title: '辅料信息',
  },
  {
    index: 3,
    title: '尺寸信息',
  },
  {
    index: 4,
    title: '面辅料商家信息',
  },
  {
    index: 5,
    title: '设计理念',
  }
]

const BASE_INFO = [
  { name: 'styleNo', label: '款号' },
  { name: 'codon', label: '基码' },
  { name: 'model', label: '版型' },
  { name: 'color', label: '颜色' },
  { name: 'category', label: '品类' },
  { name: 'season', label: '季节' },
  { name: 'modelMaker', label: '版师' },
  { name: 'sampleMaker', label: '样衣工' },
  { name: 'designer', label: '设计师' },
  { name: 'stylePlan', label: '款式计划' },
  { name: 'styleType', label: '款式类别' },
]

const MEASURE_INFO_COAT = [
  { name: 'clothLength', label: '衣长' },
  { name: 'shoulderBreadth', label: '肩宽' },
  { name: 'chestCircumference', label: '胸围' },
  { name: 'waistline', label: '腰围' },
  { name: 'hipline', label: '臀围' },
  { name: 'sleeveLength', label: '袖长' },
  { name: 'cuff', label: '袖口围' },
  { name: 'hemWidth', label: '摆围' },
]

const MEASURE_INFO_PANTS = [
  { name: 'pantsLength', label: '裙/裤外长' },
  { name: 'pantsWaistline', label: '腰围' },
  { name: 'pantsHipline', label: '臀围' },
  { name: 'frontSize', label: '前浪' },
  { name: 'backSize', label: '后浪' },
  { name: 'centerSize', label: '中档' },
  { name: 'feetSize', label: '脚口' },
  { name: 'hemSize', label: '下摆' },
]

const FABRIC_MERCHANTS = [
  { name: 'fabricMerchantA', label: '面料小样A商家' },
  { name: 'fabricMerchantB', label: '面料小样B商家' },
  { name: 'liningMerchantA', label: '里布小样A商家' },
  { name: 'liningMerchantB', label: '里布小样B商家' },
]

const COLOR_LIST = ['#6B88FF', '#5EB2FC', '#3FD2E0', '#5FE1A4', '#FCB35E', '#FC985E', '#FF7272', '#DA5EFC', '#B45EFC', '#FFC000']

const query = qs.parse(location.search, { ignoreQueryPrefix: true })

export default () => {
  const { userInfo = {} } = useContext(AccountContext)
  const [galleryVisible, setGalleryVisible] = useState(false)
  const [gallery, setGallery] = useState([])
  const [titleIndex, setTitleIndex] = useState(0)
  const [loading, setLoading] = useState(true)
  const [galleryLoading, setgalleryLoading] = useState(true)
  const [data, setData] = useState({})
  const [focusData, setFocusData] = useState({ requestBody: { focus: '-' }, requestType: SOCKET_STATUS.LOCATION_SEND })
  const [ingredientsInfo, setIngredientsInfo] = useState([])
  const [designers, setDesigners] = useState([])
  const [onLineUsers, setOnLineUsers] = useState([])
  const [editedCount, setEditedCount] = useState(0)
  const [permissions, setPermissions] = useState(false)
  const [blurState, setBlurState] = useState(false)
  const [focusKey, setFocusKey] = useState({ inputKey: '', inputValue: '', originValue: '' })
  const [online, setOnline] = useState(0)
  const {
    state,
    socketSend,
  } = useSocket({ permissions, accountInfo: userInfo })
  const $titleContent = useRef()
  const $infoContent = useRef()
  // 用于页面滚动
  const $container = useRef()
  const $baseInfo = useRef()
  const $material = useRef()
  const $sizeInfo = useRef()
  const $merchantInfo = useRef()
  const $designConcept = useRef()
  let baseInfoTop = $baseInfo.current?.offsetTop
  let materialTop = $material.current?.offsetTop
  let sizeInfoTop = $sizeInfo.current?.offsetTop
  let merchantInfoTop = $merchantInfo.current?.offsetTop
  let designConceptTop = $designConcept.current?.offsetTop

  const handScroll = useCallback((e) => {
    baseInfoTop = $baseInfo.current?.offsetTop
    materialTop = $material.current?.offsetTop
    sizeInfoTop = $sizeInfo.current?.offsetTop
    merchantInfoTop = $merchantInfo.current?.offsetTop
    designConceptTop = $designConcept.current?.offsetTop
    if (e.target.scrollTop < baseInfoTop) {
      setTitleIndex(0)
    } else if (e.target.scrollTop < materialTop) {
      setTitleIndex(1)
    } else if (e.target.scrollTop < sizeInfoTop) {
      setTitleIndex(2)
    } else if (e.target.scrollTop < merchantInfoTop) {
      setTitleIndex(3)
    } else if (e.target.scrollTop < designConceptTop) {
      setTitleIndex(4)
    }
  })
  useEffect(() => {
    $container.current?.addEventListener('scroll', handScroll)
    return () => $container.current?.removeEventListener('scroll', handScroll)
  }, [handScroll])

  const handResize = useCallback((e) => {
    $titleContent.current.style.left = `${(e.target.innerWidth - 890) / 2}px`
    $infoContent.current.style.right = `${(e.target.innerWidth - 890) / 2}px`
  })

  useEffect(() => {
    window.addEventListener('resize', handResize)
    return () => window.removeEventListener('resize', handResize)
  }, [])

  const onTitleChange = (index) => {
    setTitleIndex(index)
    if (index == 0) {
      $container.current.scrollTop = 0
    }
    if (index == 1) {
      $container.current.scrollTop = baseInfoTop
    }
    if (index == 2) {
      $container.current.scrollTop = materialTop
    }
    if (index == 3) {
      $container.current.scrollTop = sizeInfoTop
    }
    if (index == 4) {
      $container.current.scrollTop = merchantInfoTop
    }
    if (index == 5) {
      $container.current.scrollTop = designConceptTop
    }
  }

  useEffect(() => {
    fetchPerm(query.collectId)
    fetchImgDetail(query.unionId, query.blogId, query.inspirationId, query.platformId)
  }, [])

  useEffect(() => {
    const messageSocket = PubSub.subscribe('message', (topic, socketData) => {
      if (socketData) {
        if (socketData.notifyType == SOCKET_STATUS.HEART_BEAT) {
          setOnline(socketData.message.online)
          setEditedCount(socketData.message.editedCount)
          setOnLineUsers(socketData.message.onlineUsers)
        }
        if (socketData.notifyType == SOCKET_STATUS.OPEN_SEND) {
          setIngredientsInfo(socketData.message.ingredients)
          setData(socketData.message)
        }
        if (socketData.notifyType == SOCKET_STATUS.LOCATION_SEND) {
          setDesigners(convertDesigners(socketData.message.userFocusList, userInfo?.userId, COLOR_LIST))
        }
      }
    })
    return () => {
      PubSub.unsubscribe(messageSocket)
    }
  }, [focusKey])

  useEffect(() => {
    const convertData = {
      requestBody: data,
      requestType: SOCKET_STATUS.OPEN_SEND
    }
    socketSend(convertData, 'blur')
  }, [blurState])

  useEffect(() => {
    socketSend(focusData, 'focus')
  }, [focusData])

  const fetchPerm = async (collectId) => {
    if (!collectId) return
    setLoading(true)
    try {
      const res = await request.get(`/zhikuan/mn/plate/get?collectId=${collectId}`)
      if (res) {
        setPermissions(true)
      }
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  const fetchImgDetail = async (unionId, blogId, inspirationId, platformId) => {
    setgalleryLoading(true)
    try {
      const imgInfoList = await getData({ unionId, blogId, inspirationId, platformId })
      setGallery(imgInfoList)
    } catch (err) {
      console.error(err)
    }
    setgalleryLoading(false)
  }

  const convertDesigners = (userFocusList, userId, colorList) => {
    if (userFocusList && userFocusList.length > 0) {
      return userFocusList.map((i, index) => {
        const rObj = {}
        rObj.username = i.username
        rObj.userId = i.userId
        rObj.focus = i.focus
        rObj.color = colorList[index]
        return rObj
      })
    }
    return []
  }

  const onUpload = async (file) => {
    setGalleryVisible(false)
    file.forEach((v) => {
      events.onChangeData({ picUrl: { ...data.picUrl, picUrl: v.url, width: v.width, height: v.height } }, true)
    })
  }

  const scaleBig = (picUrl, width, height) => {
    // 需要在上传时就给出图片的宽高
    PicturePreview.show({ src: picUrl, picWidth: width, picHeight: height })
  }

  const getBorderColor = (inputKey) => {
    return designers?.find(des => des.focus == inputKey)
      ? { borderColor: JSON.parse(JSON.stringify(designers))?.reverse().find(des => des.focus == inputKey).color } : {}
  }

  const events = {
    onChangeData(newParams, isSkip) {
      if (focusKey?.inputValue != focusKey?.originValue || isSkip) {
        setData(pre => ({ ...pre, ...newParams }))
        setBlurState(!blurState)
      }
    },
    onChangeFocusData(newParams) {
      setFocusData(pre => ({ ...pre, ...newParams }))
    },
    addMaterial() {
      if (ingredientsInfo.length >= 16) {
        return message.error('最多支持16条辅料信息!')
      }
      ingredientsInfo.push({ name: '', count: '' })
      setData(pre => ({ ...pre, ingredients: [...ingredientsInfo] }))
      setBlurState(!blurState)
    },
    onMaterialChange(index, key, value) {
      if (focusKey.inputValue != focusKey.originValue) {
        ingredientsInfo[index][key] = value
        setData(pre => ({ ...pre, ingredients: [...ingredientsInfo] }))
        setBlurState(!blurState)
      }
    },
    deleteMaterial(index) {
      if (ingredientsInfo.length <= 1) {
        return message.error('最少保留一条!')
      }
      if (ingredientsInfo[index].name == null) {
        ingredientsInfo[index].name = ''
      }
      if (ingredientsInfo[index].count == null) {
        ingredientsInfo[index].count = ''
      }
      if (ingredientsInfo[index].name != '' || ingredientsInfo[index].count != '') {
        Modal.show({
          title: '删除确认',
          children: '是否删除已填写内容？',
          onOk: () => {
            ingredientsInfo.splice(index, 1)
            setData(pre => ({ ...pre, ingredients: [...ingredientsInfo] }))
            setBlurState(!blurState)
          },
        })
      } else {
        ingredientsInfo.splice(index, 1)
        setData(pre => ({ ...pre, ingredients: [...ingredientsInfo] }))
        setBlurState(!blurState)
      }
    },

  }

  return (loading || galleryLoading) ? <Loading spinning wrapperClassName="spin-transparent-bg"><div style={{ height: 400 }} /></Loading> : <div className="mn-edit-process-container">
    {/* 人数达到上限时的遮罩层 */}
    {(!permissions || online >= 10) && <div className="mn-edit-process-container-mask">
      <div className="mask-content">
        <div className="content-img">
          <div className="img" />
        </div>
        <div className="content-text">
          {!permissions
            ? <span>您暂时没有权限。</span>
            : <><span>当前制版单同时在线人数已满，</span><br />
              <span>请稍后刷新重试。</span></>}
        </div>
      </div>
    </div>}
    {!state && <div className="mn-edit-process-reconnection-mask">
      <div className="reconnection-box">
        <Spin />
        <span style={{ marginLeft: 20 }}>重连中，请稍等!</span>
      </div>
    </div>}
    <div className="process-header">
      <div className="header-title">编辑制版单</div>
      <div className="header-abstract">所有编辑内容，系统将自动保存</div>
    </div>
    <div className="process-content" ref={$container}>
      <div className="content-title" ref={$titleContent} style={{ left: `${(window.innerWidth - 890) / 2}px` }}>
        {
          DESIGN_TITLE.map((item, index) => {
            return <a onClick={() => onTitleChange(index)} className={classNames('title-item', { active: index === titleIndex })}>
              <span />
              <span>{item.title}</span>
            </a>
          })
        }
        <Dropdown
          overlay={<ManageModal
            imageGroupEntityId={query.imageGroupEntityId}
            inspirationId={query.inspirationId}
            onLineUsers={onLineUsers}
            editedCount={editedCount}
          />}
          trigger={['click']}
          getPopupContainer={triggerNode => triggerNode}
        >
          <div className="management-btn">
            协作管理<Icon type="m-Vxing_you" style={{ marginLeft: '8px' }} />
          </div>
        </Dropdown>
      </div>
      <div className="content-info" ref={$infoContent} style={{ right: `${(window.innerWidth - 890) / 2}px` }}>
        <div className="header-placeholder" />
        <InfoCard title="款式图管理" cardClass="pictureCard">
          <div className="preview">预览</div>
          {data.picUrl && Object.keys(data.baseInfo).length > 0 ? <div className="picture" style={{ backgroundImage: `url(${data.picUrl.picUrl})` }}>
            <div className="scale-big" onClick={() => scaleBig(data.picUrl.picUrl, data.picWidth, data.picHeight)} />
          </div> : null}
          <Mndropdown
            trigger="click"
            overlay={<Ul style={{ width: 130 }}>
              <Li onClick={() => setGalleryVisible(true)}>款式图库</Li>
              <Li>
                <Upload
                  onSuccess={file => onUpload(file)}
                  customDir="data_infra/26/"
                  maxSize={10}
                  directory={false}
                >本地上传</Upload>
              </Li>
            </Ul>}
          >
            <div className="add-img">更换款式图</div>
          </Mndropdown>
        </InfoCard>
        <div ref={$baseInfo}>
          <InfoCard title="基本信息" cardClass="baseInfo">
            {data.baseInfo && Object.keys(data.baseInfo).length > 0 ? BASE_INFO.map((item) => {
              return <InputBox title={item.label} key={item.label} designers={designers} inputKey={item.name}>
                <Input
                  wrapStyle={getBorderColor(item.name)}
                  wrapClassName="edit-process-input"
                  // value={data.baseInfo[item.name]}
                  value={focusKey.inputKey == item.name ? focusKey.inputValue : data.baseInfo[item.name]}
                  onBlur={(e) => {
                    events.onChangeData({ baseInfo: { ...data.baseInfo, [item.name]: e.target.value } })
                    events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: '-' } })
                    setFocusKey(pre => ({ ...pre, inputKey: '' }))
                  }}
                  onInput={(e) => {
                    const inputValue = e.target.value
                    setFocusKey(pre => ({ ...pre, inputValue }))
                  }}
                  onFocus={(e) => {
                    events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: item.name } })
                    const inputValue = e.target.value
                    setFocusKey(pre => ({ ...pre, inputKey: item.name, inputValue, originValue: inputValue }))
                  }}
                />
              </InputBox>
            }) : null}
          </InfoCard>
        </div>
        <div ref={$material}>
          <InfoCard title="辅料信息" cardClass="material-info">
            {ingredientsInfo && ingredientsInfo.length > 0 ? ingredientsInfo.map((item, index) => {
              return <MaterialBox
                index={index}
                name={item.name}
                count={item.count}
                focusData={focusData}
                designers={designers}
                events={events}
                focusKey={focusKey}
                setFocusKey={setFocusKey}
              />
            }) : null}
            {ingredientsInfo && ingredientsInfo.length < 16 ? <div className="material-add" onClick={events.addMaterial}><Icon type="m-tianjia" />添加辅料信息</div> : null}
          </InfoCard>
        </div>
        <div ref={$sizeInfo}>
          <InfoCard title="尺寸信息" cardClass="sizeInfo">
            <div className="coat-size">上衣尺寸</div>
            <div className="size-content">
              {data.measureInfo && Object.keys(data.measureInfo).length > 0 ? MEASURE_INFO_COAT.map((item) => {
                return <InputBox title={item.label} key={item.label} designers={designers} inputKey={item.name}>
                  <Input
                    wrapStyle={getBorderColor(item.name)}
                    wrapClassName="edit-process-input"
                    // value={data.measureInfo[item.name]}
                    value={focusKey.inputKey == item.name ? focusKey.inputValue : data.measureInfo[item.name]}
                    onBlur={(e) => {
                      events.onChangeData({ measureInfo: { ...data.measureInfo, [item.name]: e.target.value } })
                      events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: '-' } })
                      setFocusKey(pre => ({ ...pre, inputKey: '' }))
                    }}
                    onInput={(e) => {
                      const inputValue = e.target.value
                      setFocusKey(pre => ({ ...pre, inputValue }))
                    }}
                    onFocus={(e) => {
                      events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: item.name } })
                      const inputValue = e.target.value
                      setFocusKey(pre => ({ ...pre, inputKey: item.name, inputValue, originValue: inputValue }))
                    }}
                  />
                </InputBox>
              }) : null}
            </div>
            <div className="coat-size">裙/裤尺寸</div>
            <div className="size-content">
              {data.measureInfo && Object.keys(data.measureInfo).length > 0 ? MEASURE_INFO_PANTS.map((item) => {
                return <InputBox title={item.label} key={item.label} designers={designers} inputKey={item.name}>
                  <Input
                    wrapStyle={getBorderColor(item.name)}
                    wrapClassName="edit-process-input"
                    // value={data.measureInfo[item.name]}
                    value={focusKey.inputKey == item.name ? focusKey.inputValue : data.measureInfo[item.name]}
                    onBlur={(e) => {
                      events.onChangeData({ measureInfo: { ...data.measureInfo, [item.name]: e.target.value } })
                      events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: '-' } })
                      setFocusKey(pre => ({ ...pre, inputKey: '' }))
                    }}
                    onInput={(e) => {
                      const inputValue = e.target.value
                      setFocusKey(pre => ({ ...pre, inputValue }))
                    }}
                    onFocus={(e) => {
                      events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: item.name } })
                      const inputValue = e.target.value
                      setFocusKey(pre => ({ ...pre, inputKey: item.name, inputValue, originValue: inputValue }))
                    }}
                  />
                </InputBox>
              }) : null}
            </div>
          </InfoCard>
        </div>
        <div ref={$merchantInfo}>
          <InfoCard title="面辅料商家信息" cardClass="merchantInfo">
            {data && Object.keys(data).length > 0
              ? FABRIC_MERCHANTS.map((item) => {
                return <>
                  <div className="merchants-mask">{item.label}</div>
                  <div className="small-kind-content">
                    <div className="content-top">
                      <InputBox title="名称" designers={designers} inputKey={`${item.name}_name`}>
                        <Input
                          wrapStyle={getBorderColor(`${item.name}_name`)}
                          wrapClassName="edit-process-input"
                          // value={data[item.name].name}
                          value={focusKey.inputKey == `${item.name}_name` ? focusKey.inputValue : data[item.name].name}
                          onBlur={(e) => {
                            events.onChangeData({ [item.name]: { ...data[item.name], name: e.target.value } })
                            events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: '-' } })
                            setFocusKey(pre => ({ ...pre, inputKey: '' }))
                          }}
                          onInput={(e) => {
                            const inputValue = e.target.value
                            setFocusKey(pre => ({ ...pre, inputValue }))
                          }}
                          onFocus={(e) => {
                            events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: `${item.name}_name` } })
                            const inputValue = e.target.value
                            setFocusKey(pre => ({ ...pre, inputKey: `${item.name}_name`, inputValue, originValue: inputValue }))
                          }}
                        />
                      </InputBox>
                      <InputBox title="电话" designers={designers} inputKey={`${item.name}_phone`}>
                        <Input
                          wrapStyle={getBorderColor(`${item.name}_phone`)}
                          wrapClassName="edit-process-input"
                          // value={data[item.name].phone}
                          value={focusKey.inputKey == `${item.name}_phone` ? focusKey.inputValue : data[item.name].phone}
                          onBlur={(e) => {
                            events.onChangeData({ [item.name]: { ...data[item.name], phone: e.target.value } })
                            events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: '-' } })
                            setFocusKey(pre => ({ ...pre, inputKey: '' }))
                          }}
                          onInput={(e) => {
                            const inputValue = e.target.value
                            setFocusKey(pre => ({ ...pre, inputValue }))
                          }}
                          onFocus={(e) => {
                            events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: `${item.name}_phone` } })
                            const inputValue = e.target.value
                            setFocusKey(pre => ({ ...pre, inputKey: `${item.name}_phone`, inputValue, originValue: inputValue }))
                          }}
                        />
                      </InputBox>
                    </div>
                    <div className="content-bot">
                      <InputBox title="地址" inputClass="small-kill-address" designers={designers} inputKey={`${item.name}_address`}>
                        <Input
                          wrapStyle={getBorderColor(`${item.name}_address`)}
                          wrapClassName="edit-process-input"
                          // value={data[item.name].address}
                          value={focusKey.inputKey == `${item.name}_address` ? focusKey.inputValue : data[item.name].address}
                          onBlur={(e) => {
                            events.onChangeData({ [item.name]: { ...data[item.name], address: e.target.value } })
                            events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: '-' } })
                            setFocusKey(pre => ({ ...pre, inputKey: '' }))
                          }}
                          onInput={(e) => {
                            const inputValue = e.target.value
                            setFocusKey(pre => ({ ...pre, inputValue }))
                          }}
                          onFocus={(e) => {
                            events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: `${item.name}_address` } })
                            const inputValue = e.target.value
                            setFocusKey(pre => ({ ...pre, inputKey: `${item.name}_address`, inputValue, originValue: inputValue }))
                          }}
                        />
                      </InputBox>
                    </div>
                  </div></>
              }) : null}
          </InfoCard>
        </div>
        <div ref={$designConcept}>
          <InfoCard title="设计理念" cardClass="designConcept">
            <Textarea
              placeholder="聊聊该款式的设计理念"
              wrapStyle={getBorderColor('designPhilosophy')}
              wrapClassName="designConcept-textarea"
              withBorder
              minHeight={100}
              maxLength={140}
              suffix={<div className="suffix">140</div>}
              // value={data?.designPhilosophy}
              value={focusKey.inputKey == 'designPhilosophy' ? focusKey.inputValue : data.designPhilosophy}
              onBlur={(e) => {
                events.onChangeData({ designPhilosophy: e.target.value })
                events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: '-' } })
                setFocusKey(pre => ({ ...pre, inputKey: '' }))
              }}
              onInput={(e) => {
                const inputValue = e.target.value
                setFocusKey(pre => ({ ...pre, inputValue }))
              }}
              onFocus={(e) => {
                events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: 'designPhilosophy' } })
                const inputValue = e.target.value
                setFocusKey(pre => ({ ...pre, inputKey: 'designPhilosophy', inputValue, originValue: inputValue }))
              }}
            />
            <div className="current-user" title={designers?.filter(item => item.focus == 'designPhilosophy')?.map(des => des.username)}>
              {designers?.filter(item => item.focus == 'designPhilosophy')?.map((designer) => {
                return <div className="user-item" style={{ color: designer.color }}>{designer.username}<Icon type="m-kuaisubianji" /></div>
              })}
            </div>
          </InfoCard>
        </div>
        <div className="footer-placeholder" />
      </div>
    </div>
    <GalleryModal
      visible={galleryVisible}
      setVisible={setGalleryVisible}
      gallery={gallery}
      onUpload={onUpload}
      maxSize={10}
      currentImg={data?.picUrl?.picUrl}
      blogId={query.blogId}
      inspirationId={query.inspirationId}
      onChange={img => events.onChangeData({ picUrl: { ...data.picUrl, picUrl: img.mainUrl, width: img.width, heigth: img.height } }, true)}
    />
  </div>
}

const InfoCard = (props) => {
  const { title, cardClass } = props
  return <div className={classNames('process-card', cardClass)}>
    <div className="card-title">{title}</div>
    <div className="card-content">{props.children}</div>
  </div>
}

const InputBox = (props) => {
  const { title, inputClass, designers, inputKey } = props
  return <div className={classNames('input-box', inputClass)}>
    <div className="box-title">{title}</div>
    {props.children}
    <div className="current-user" title={designers?.filter(item => item.focus == inputKey)?.map(des => des.username)}>
      {designers?.filter(item => item.focus == inputKey)?.map((designer) => {
        return <div className="user-item" style={{ color: designer.color }}>{designer.username}<Icon type="m-kuaisubianji" /></div>
      })}
    </div>
  </div>
}

const MaterialBox = (props) => {
  const { index, name, count, focusData, designers, events, focusKey, setFocusKey } = props
  return <div className="material-box">
    <div className="material-box-header">
      <div className="header-title">辅料&nbsp;{index + 1}&nbsp;信息</div>
      <div className="header-delete" onClick={() => events.deleteMaterial(index)}><Icon type="m-shanchu" />&nbsp;删除</div>
    </div>
    <div className="material-box-content">
      <InputBox title="名称" designers={designers} inputKey={`${index}_name`}>
        <Input
          wrapStyle={designers?.find(des => des.focus == `${index}_name`) ? { borderColor: JSON.parse(JSON.stringify(designers))?.reverse().find(des => des.focus == `${index}_name`).color } : {}}
          wrapClassName="edit-process-input"
          // value={name}
          value={focusKey.inputKey == `${index}_name` ? focusKey.inputValue : name}
          onBlur={(e) => {
            events.onMaterialChange(index, 'name', e.target.value)
            events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: '-' } })
            setFocusKey(pre => ({ ...pre, inputKey: '' }))
          }}
          onInput={(e) => {
            const inputValue = e.target.value
            setFocusKey(pre => ({ ...pre, inputValue }))
          }}
          onFocus={(e) => {
            events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: `${index}_name` } })
            const inputValue = e.target.value
            setFocusKey(pre => ({ ...pre, inputKey: `${index}_name`, inputValue, originValue: inputValue }))
          }}
        />
      </InputBox>
      <InputBox title="数量" designers={designers} inputKey={`${index}_count`}>
        <Input
          wrapStyle={designers?.find(des => des.focus == `${index}_count`) ? { borderColor: JSON.parse(JSON.stringify(designers))?.reverse().find(des => des.focus == `${index}_count`).color } : {}}
          wrapClassName="edit-process-input"
          // value={count}
          value={focusKey.inputKey == `${index}_count` ? focusKey.inputValue : count}
          onBlur={(e) => {
            events.onMaterialChange(index, 'count', e.target.value)
            events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: '-' } })
            setFocusKey(pre => ({ ...pre, inputKey: '' }))
          }}
          onInput={(e) => {
            const inputValue = e.target.value
            setFocusKey(pre => ({ ...pre, inputValue }))
          }}
          onFocus={(e) => {
            events.onChangeFocusData({ requestBody: { ...focusData?.requestBody, focus: `${index}_count` } })
            const inputValue = e.target.value
            setFocusKey(pre => ({ ...pre, inputKey: `${index}_count`, inputValue, originValue: inputValue }))
          }}
        />
      </InputBox>
    </div>
  </div>
}

const ManageModal = (props) => {
  const { imageGroupEntityId, inspirationId, onLineUsers, editedCount } = props
  const $input = useRef()
  const [inputValue, setInputValue] = useState('')
  useEffect(() => {
    setInputValue(location.href)
  }, [])
  const copyLink = () => {
    $input.current.select()
    document.execCommand('copy')
    message.success('复制成功!')
  }
  return <div className="manage-modal">
    <div className="manage-record">
      <span>访问记录</span>
      <span>{onLineUsers?.length}人看过</span>
      <span>{editedCount}人编辑过</span>
    </div>
    <div className="manage-users">
      {
        onLineUsers && onLineUsers.length > 0 && onLineUsers.map((item) => {
          return <div className="user-item">
            <div className="user-portrait" style={{ backgroundImage: `url(${item.avatar})` }} />
            <div className="user-name" title={item.username}>{item.username}</div>
            {item.online && <div className="user-status"><span className="status-icon">▪</span>当前在线</div>}
          </div>
        })
      }
    </div>
    <div className="manage-share">
      <div className="share-title">分享链接</div>
      <div className="copy-content">
        <input type="text" value={inputValue} ref={$input} />
        <div className="copy-btn" onClick={copyLink}>复制链接</div>
      </div>
    </div>
    <a
      onClick={async () => {
        try {
          await request.downloadBlob(`/api/zhikuan/style-receipts/export?blogId=${imageGroupEntityId}&inspirationId=${inspirationId}`, `制版单_${inspirationId || '款式'}.xlsx`, false)
        } catch (error) {
          message.error('下载失败，请重试')
        }
      }}
    ><div className="download-btn">下载制版单</div></a>
  </div>
}

const GalleryModal = (props) => {
  const { visible, setVisible, gallery, currentImg, onChange, onUpload, maxSize } = props
  const [selectImg, setselectImg] = useState(null)
  const [img, setImg] = useState(null)
  const [page, setPage] = useState(0)

  const onClickImg = (_img) => {
    setselectImg(_img.mainUrl)
    setImg(_img)
  }
  const onSubmit = () => {
    onChange && onChange(img)
    setVisible(false)
  }
  useEffect(() => {
    if (visible) {
      setselectImg(currentImg)
    }
  }, [visible])
  return gallery?.length > 1 ? <Modal
    size="mn-edit-process-fallery-modal"
    visible={visible}
    hiddenFooter
    onClose={() => setVisible(false)}
  >
    <div className="fallery-modal-title">
      <div className="title">
        <span>更换款式图库</span>
        <span>当前款式图库图片</span>
      </div>
    </div>
    <div className="fallery-modal-container">
      {
      gallery?.length > 0 && gallery.slice(page * 10).map((item) => {
        return <div
          className="image-box"
          style={{ backgroundImage: `url(${item.mainUrl})` }}
          onClick={() => onClickImg(item)}
        >
          {item.mainUrl == selectImg && <div className="active">
            <Icon type="m-xiaoyan_tianchong" />
            </div>}
        </div>
      })
      }
    </div>
    {page > 0 && <div onClick={() => setPage(page - 1)} className="per-page"><Icon type="m-Vxing_zuo" /></div>}
    {page + 1 < Math.floor(gallery?.length / 10) && <div onClick={() => setPage(page + 1)} className="next-page"><Icon type="m-Vxing_you" /></div>}
    <div className="modal-footer">
      <Button type="normal" onClick={() => setVisible(false)} style={{ marginRight: 16, width: 112, borderRadius: '2px' }}>取消</Button>
      <Button type="primary" onClick={onSubmit} style={{ width: 112, borderRadius: '2px' }}>保存</Button>
    </div>
  </Modal> : <Modal
    size="mn-edit-process-nofallery-modal"
    visible={visible}
    hiddenFooter
    onClose={() => setVisible(false)}
  >
    <div className="nofallery-modal-title">
      <Icon type="m-zhuyi_tianchong" />
      当前款式图库为单图，暂时无法更换
    </div>
    <div className="nofallery-modal-attention">建议您从本地上传款式，或从编辑款式页面中添加款式</div>
    <div className="modal-footer">
      <Button type="normal" onClick={() => setVisible(false)} style={{ marginRight: 16, width: 112, borderRadius: '2px' }}>取消</Button>
      <Upload
        onSuccess={file => onUpload(file)}
        customDir="data_infra/26/"
        maxSize={maxSize}
        directory={false}
      >
        <Button type="primary" style={{ width: 112, borderRadius: '2px' }}>本地上传</Button>
      </Upload>
    </div>
  </Modal>
}
